import { render, staticRenderFns } from "./trays_types.vue?vue&type=template&id=0fcc4df1&scoped=true&"
import script from "./trays_types.vue?vue&type=script&lang=js&"
export * from "./trays_types.vue?vue&type=script&lang=js&"
import style0 from "./trays_types.vue?vue&type=style&index=0&id=0fcc4df1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcc4df1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fcc4df1')) {
      api.createRecord('0fcc4df1', component.options)
    } else {
      api.reload('0fcc4df1', component.options)
    }
    module.hot.accept("./trays_types.vue?vue&type=template&id=0fcc4df1&scoped=true&", function () {
      api.rerender('0fcc4df1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/trays_types.vue"
export default component.exports